import type { TherapistStore } from "../Store";
import type { TherapistLevelApi, TherapistLevelGoalApi } from "@/Modules/Models/Api/Therapist";
import type { TherapistLevel, TherapistLevelGoal } from "@/Modules/Models/Domain/Therapist";

import TherapistApiConnector from "@/Services/TherapyApi/Therapists";
import { TherapistLevelGoalIdentifierApi } from "@/Modules/Models/Api/Therapist";

import camelize from "@/Utils/Camelize";

class SetTherapistLevelActionHandler {
  constructor(
    private readonly therapistStore: TherapistStore,
    private readonly therapistApiConnector = new TherapistApiConnector()
  ) {}

  public async handle() {
    const therapistLevelApiResponse = await this.therapistApiConnector.getLevel();

    this.therapistStore.level = this.transformTherapistLevelApiToTherapistLevel(therapistLevelApiResponse);
  }

  private transformTherapistLevelApiToTherapistLevel(levelApi: TherapistLevelApi): TherapistLevel {
    const therapistLevelGoalkeyToTherapistLevelGoalI18nKeyMap: {
      [TKey in TherapistLevelGoalIdentifierApi]: string;
    } = {
      [TherapistLevelGoalIdentifierApi.DAYS_IN_LEVEL]: "days_in_current_milestone",
      [TherapistLevelGoalIdentifierApi.ACTIVE_PATIENTS]: "number_of_patients",
      [TherapistLevelGoalIdentifierApi.SQQ1_SCORE]: "welcoming_rating",
      [TherapistLevelGoalIdentifierApi.SQQ2_SCORE]: "therapeutic_process_rating",
      [TherapistLevelGoalIdentifierApi.TRIAL_TO_SUBSCRIPTION_RATE]: "rapport",
    };

    const therapistLevelGoals = levelApi.goals.map(
      (levelGoalApi: TherapistLevelGoalApi): TherapistLevelGoal => {
        const therapistLevelGoal: TherapistLevelGoal = {
          ...(camelize<TherapistLevelGoalApi, TherapistLevelGoal>(
            levelGoalApi,
            ["identifier", "max_value", "current_value"],
            ["key", "max", "value"]
          ) as Pick<TherapistLevelGoal, "key" | "max" | "value">),
          i18n: therapistLevelGoalkeyToTherapistLevelGoalI18nKeyMap[levelGoalApi.identifier],
          percentage: levelGoalApi.percentage * 100,
        };

        return therapistLevelGoal;
      }
    );

    const therapistLevel: TherapistLevel = {
      ...(camelize<TherapistLevelApi>(levelApi, ["level", "max_level", "progress"]) as Omit<
        TherapistLevel,
        "goals"
      >),
      goals: therapistLevelGoals,
    };

    return therapistLevel;
  }
}

export default SetTherapistLevelActionHandler;
